import { all, takeEvery, fork, put, select } from 'redux-saga/effects'
import actions from './actions'

function* saga_IncCount() {
    try {
        let color = yield select(state => state.home.color)
        
        let newColor = 'black'
        if (color === 'black') newColor = 'green'

        yield put(actions.action.changeColor(newColor))
    } catch (ex) {
        console.log('Inc count error : ', ex.message)
    }
}

function* listen() {
    yield takeEvery(actions.type.INC_COUNT, saga_IncCount)
}

export default function* homeSaga() {
    yield all([fork(listen)])
}
